import { GKDataGrid } from "components";
import { assetsHoldingsColumns } from "utils/columns";

interface Props {
  holdingData: any;
  holdingLoading: any;
  onRowClick?: (row: any) => void;
}

const HoldingsInsightsNew = (props: Props) => {
  const { holdingData, holdingLoading, onRowClick } = props;

  return (
    <GKDataGrid
      density="compact"
      loading={holdingLoading}
      columns={assetsHoldingsColumns}
      rows={holdingData?.data?.data || []}
      zeroHolding
      totalCount={holdingData?.data?.totalCount || 0}
      name="insights"
      tableName="insights_list"
      onRowClick={onRowClick}
      pinnedColumns={{
        left: ["name"],
      }}
      exportFile={{
        path: "/holdings/selected/",
        exportName: "HoldingSummaryList",
      }}
    />
  );
};

export default HoldingsInsightsNew;
